(() => {
  if (window.__vfUpsell) return;
  window.__vfUpsell = true;

  /* Varese upsells: variant selection + add-to-cart for "Complete the look" items.
     Uses the theme's cart event so the drawer re-renders and opens like a normal add. */

  const variantsOf = (item) => JSON.parse(item.querySelector('[data-vf-variants]').textContent);

  const selectedVariant = (item) => {
    const picks = [...item.querySelectorAll('[data-vf-opt]')].map((s) => s.value);
    const variants = variantsOf(item);
    if (!picks.length) return variants[0];
    return variants.find((v) => picks.every((value, i) => v.o[i] === value));
  };

  const missingChoice = (item) => [...item.querySelectorAll('[data-vf-opt]')].find((s) => !s.value);

  const syncItem = (item) => {
    const button = item.querySelector('[data-vf-add]');
    item.querySelectorAll('.vf-select--error').forEach((el) => el.classList.remove('vf-select--error'));
    if (missingChoice(item)) {
      button.disabled = false;
      button.textContent = button.dataset.label;
      return;
    }
    const variant = selectedVariant(item);
    const ok = Boolean(variant && variant.a);
    button.disabled = !ok;
    button.textContent = ok ? button.dataset.label : 'Sold out';
    if (variant) {
      const now = item.querySelector('.vf-look__now');
      if (now && variant.price) now.textContent = variant.price;
      const img = item.querySelector('.vf-look__media img');
      if (img && variant.img) {
        img.removeAttribute('srcset');
        img.src = variant.img;
      }
    }
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-vf-opt]');
    if (select) syncItem(select.closest('[data-vf-item]'));
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-vf-add]');
    if (!button) return;
    event.preventDefault();

    const item = button.closest('[data-vf-item]');
    const missing = missingChoice(item);
    if (missing) {
      const label = missing.closest('.vf-select');
      label.classList.remove('vf-select--error');
      void label.offsetWidth;
      label.classList.add('vf-select--error');
      missing.focus();
      return;
    }
    const variant = selectedVariant(item);
    if (!variant || !variant.a) return;

    button.disabled = true;
    button.classList.add('is-loading');

    const sectionIds = [
      ...new Set(
        [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean)
      ),
    ];
    const body = new FormData();
    body.append('id', String(variant.id));
    body.append('quantity', '1');
    if (sectionIds.length) body.append('sections', sectionIds.join(','));

    const { CartLinesUpdateEvent } = await import('@shopify/events');
    const deferred = CartLinesUpdateEvent.createPromise();
    button.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(variant.id), quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        body,
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      }).then((r) => r.json());
      if (response.status) throw new Error(response.description || response.message || 'Add to cart failed');

      const cart = await fetch(`${Theme.routes.cart_url}.js`).then((r) => r.json());
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'vf-complete-look',
          itemCount: 1,
          sections: response.sections,
          didError: false,
        },
      });
      button.textContent = 'Added';
      button.classList.add('is-added');
      setTimeout(() => {
        button.classList.remove('is-added');
        syncItem(item);
      }, 1800);
    } catch (error) {
      deferred.reject(error);
      button.textContent = 'Try again';
      console.error('[vf-upsell]', error);
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  });

})();
